<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="quiz.id === null">{{ 'NEWQUIZ' | translate }}</span>
            <span *ngIf="quiz.id !== null">{{ 'EDITQUIZ' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="quizForm" id="quizForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="quizForm" >
            <input type="hidden" name="id" id="quizId" formControlName="id" />
            <div class="p-fluid p-grid">
             
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizTitle" formControlName="title" type="text" pInputText [required]="true"> 
                      <label for="quizTitle" class="req">{{ 'TITLE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="quizForm.controls['title'].invalid && (quizForm.controls['title'].dirty || quizForm.controls['title'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['title'].errors !== null">
                  <div *ngIf="quizForm.controls['title'].errors.required">
                   {{ 'TITLEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizTitleAr" formControlName="titleAr" type="text" pInputText [required]="false"> 
                      <label for="quizTitleAr" class="">{{ 'TITLEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="quizTitleFr" class="">{{ 'TITLEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
    
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="quizDescription" class="req">{{ 'DESCRIPTION' | translate }}</label>
                    <ckeditor formControlName="description" [editor]="Editor" id="quizDescription" name="description" [config]="editorService.config"></ckeditor>
                </div>
                <div *ngIf="quizForm.controls['description'].invalid && (quizForm.controls['description'].dirty || quizForm.controls['description'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['description'].errors !== null">
                  <div *ngIf="quizForm.controls['description'].errors.required">
                   {{ 'DESCRIPTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="quizDescriptionAr" class="">{{ 'DESCRIPTIONAR' | translate }}</label>
                    <ckeditor formControlName="descriptionAr" [editor]="Editor" id="quizDescriptionAr" name="descriptionAr" [config]="editorService.config"></ckeditor>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="quizDescriptionFr" class="">{{ 'DESCRIPTIONFR' | translate }}</label>
                    <ckeditor formControlName="descriptionFr" [editor]="Editor" id="quizDescriptionFr" name="descriptionFr" [config]="editorService.config"></ckeditor>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <label for="quizKind" class="req">{{ 'KIND' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of quizzesColumnsService.kindsOptions; let i = index">
                      <p-radioButton inputId="quizKind_{{ i }}" formControlName="kind" name="kind" [value]="option.value"></p-radioButton>
                      <label for="quizKind_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="quizForm.controls['kind'].invalid && (quizForm.controls['kind'].dirty || quizForm.controls['kind'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['kind'].errors !== null">
                  <div *ngIf="quizForm.controls['kind'].errors.required">
                   {{ 'KINDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-help"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizQuestion" formControlName="question" type="text" pInputText [required]="true"> 
                      <label for="quizQuestion" class="req">{{ 'QUESTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="quizForm.controls['question'].invalid && (quizForm.controls['question'].dirty || quizForm.controls['question'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['question'].errors !== null">
                  <div *ngIf="quizForm.controls['question'].errors.required">
                   {{ 'QUESTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-help"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizQuestionAr" formControlName="questionAr" type="text" pInputText [required]="false"> 
                      <label for="quizQuestionAr" class="">{{ 'QUESTIONAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-help"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizQuestionFr" formControlName="questionFr" type="text" pInputText [required]="false"> 
                      <label for="quizQuestionFr" class="">{{ 'QUESTIONFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice1" formControlName="choice1" type="text" pInputText [required]="false"> 
                      <label for="quizChoice1" class="">{{ 'CHOICE1' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice1Ar" formControlName="choice1Ar" type="text" pInputText [required]="false"> 
                      <label for="quizChoice1Ar" class="">{{ 'CHOICE1AR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice1Fr" formControlName="choice1Fr" type="text" pInputText [required]="false"> 
                      <label for="quizChoice1Fr" class="">{{ 'CHOICE1FR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="quizChoice1IsCorrect" formControlName="choice1IsCorrect" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="quizChoice1IsCorrect" class="p-d-inline-block p-ml-2 req">{{ 'CHOICE1ISCORRECT' | translate }}</label>
                </div>
                <div *ngIf="quizForm.controls['choice1IsCorrect'].invalid && (quizForm.controls['choice1IsCorrect'].dirty || quizForm.controls['choice1IsCorrect'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['choice1IsCorrect'].errors !== null">
                  <div *ngIf="quizForm.controls['choice1IsCorrect'].errors.required">
                   {{ 'CHOICE1ISCORRECTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice2" formControlName="choice2" type="text" pInputText [required]="false"> 
                      <label for="quizChoice2" class="">{{ 'CHOICE2' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice2Ar" formControlName="choice2Ar" type="text" pInputText [required]="false"> 
                      <label for="quizChoice2Ar" class="">{{ 'CHOICE2AR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice2Fr" formControlName="choice2Fr" type="text" pInputText [required]="false"> 
                      <label for="quizChoice2Fr" class="">{{ 'CHOICE2FR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="quizChoice2IsCorrect" formControlName="choice2IsCorrect" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="quizChoice2IsCorrect" class="p-d-inline-block p-ml-2 req">{{ 'CHOICE2ISCORRECT' | translate }}</label>
                </div>
                <div *ngIf="quizForm.controls['choice2IsCorrect'].invalid && (quizForm.controls['choice2IsCorrect'].dirty || quizForm.controls['choice2IsCorrect'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['choice2IsCorrect'].errors !== null">
                  <div *ngIf="quizForm.controls['choice2IsCorrect'].errors.required">
                   {{ 'CHOICE2ISCORRECTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice3" formControlName="choice3" type="text" pInputText [required]="false"> 
                      <label for="quizChoice3" class="">{{ 'CHOICE3' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice3Ar" formControlName="choice3Ar" type="text" pInputText [required]="false"> 
                      <label for="quizChoice3Ar" class="">{{ 'CHOICE3AR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice3Fr" formControlName="choice3Fr" type="text" pInputText [required]="false"> 
                      <label for="quizChoice3Fr" class="">{{ 'CHOICE3FR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="quizChoice3IsCorrect" formControlName="choice3IsCorrect" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="quizChoice3IsCorrect" class="p-d-inline-block p-ml-2 req">{{ 'CHOICE3ISCORRECT' | translate }}</label>
                </div>
                <div *ngIf="quizForm.controls['choice3IsCorrect'].invalid && (quizForm.controls['choice3IsCorrect'].dirty || quizForm.controls['choice3IsCorrect'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['choice3IsCorrect'].errors !== null">
                  <div *ngIf="quizForm.controls['choice3IsCorrect'].errors.required">
                   {{ 'CHOICE3ISCORRECTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice4" formControlName="choice4" type="text" pInputText [required]="false"> 
                      <label for="quizChoice4" class="">{{ 'CHOICE4' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice4Ar" formControlName="choice4Ar" type="text" pInputText [required]="false"> 
                      <label for="quizChoice4Ar" class="">{{ 'CHOICE4AR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-dot-circle"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="quizChoice4Fr" formControlName="choice4Fr" type="text" pInputText [required]="false"> 
                      <label for="quizChoice4Fr" class="">{{ 'CHOICE4FR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="quizChoice4IsCorrect" formControlName="choice4IsCorrect" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="quizChoice4IsCorrect" class="p-d-inline-block p-ml-2 req">{{ 'CHOICE4ISCORRECT' | translate }}</label>
                </div>
                <div *ngIf="quizForm.controls['choice4IsCorrect'].invalid && (quizForm.controls['choice4IsCorrect'].dirty || quizForm.controls['choice4IsCorrect'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['choice4IsCorrect'].errors !== null">
                  <div *ngIf="quizForm.controls['choice4IsCorrect'].errors.required">
                   {{ 'CHOICE4ISCORRECTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
          
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" >
                  <label for="quizStatus" class="req">{{ 'STATUS' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of quizzesColumnsService.statusesOptions; let i = index">
                      <p-radioButton inputId="quizStatus_{{ i }}" formControlName="status" name="status" [value]="option.value"></p-radioButton>
                      <label for="quizStatus_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="quizForm.controls['status'].invalid && (quizForm.controls['status'].dirty || quizForm.controls['status'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="quizForm.controls['status'].errors !== null">
                  <div *ngIf="quizForm.controls['status'].errors.required">
                   {{ 'STATUSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            
            </div><!--/p-fluid p-grid-->
         
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" >
                  <label for="quizLevel" class="req">{{ 'Level' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of quizzesColumnsService.levelsOptions; let i = index">
                      <p-radioButton inputId="quizLevel{{ i }}" formControlName="level " name="level " [value]="option.value"></p-radioButton>
                      <label for="quizLevel{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
               

              </div><!--/p-col-6-->
            
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKQUIZZES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="quiz.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!quizForm.valid || disableSubmit"> <!--  [disabled]="quizForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!quizForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

